import React, {Component, ReactElement, ReactNode} from 'react'
import {Nullable} from '../../../../app/TypeHelpers'
import {
    PaymentInformation,
    PaymentItem,
    ReservationOption,
    ReserveFacilityModel,
    ReserveFacilityModelPaymentObserver,
} from '../../../../components/reservations/ReserveFacilityModel'
import {ConditionTableFixed} from '../../../../styledComponents/adminPage/ConditionTable'
import {StyledTableCaption, TableRowName} from '../../../../styledComponents/adminPage/Table'
import {PaymentItemForViewFacility} from '../../../../components/reservations/element/PaymentItemForViewFacility'
import {CASH_PAYMENT_STATUS, FACILITY_RESERVATION_CLASSIFICATION, PAYMENT_TYPE,} from '../../../../CodeMaster'
import {NatAdminFacilityReserveInfo, NatFacilityOptionDetailInfo} from './NatAdminFacilityReserve'
import {COMMON_CONSTANTS} from '../../../../CommonConstants'
import {calculateDurations, convertToMoment} from '../../../../components/reservations/helpers/helpers'
import * as moment from 'moment'
import {FacilityReserveCharge} from '../repository/NatPutFacilityReserveOvernight'
import styled from 'styled-components'
import {FacilityOption} from '../../../../components/reservations/ResidentReserveFacilityFormComponents/RRFFReserveOptionInput'
import {TableBody, TableCell, TableRow} from '@mui/material'

interface Props {
    reservationModel: ReserveFacilityModel
    facilityName: string
    facilityReserveCategory: string
    facilityReserveEditInfo: NatAdminFacilityReserveInfo
    facilityOptions: FacilityOption[]
    facilityOptionsDetailInfo: NatFacilityOptionDetailInfo[]
    reservationOptions: ReservationOption[]
    stayAvailability: boolean
    onChangeTotalCharge: (totalCharge: Nullable<number>) => void
    onChangeFacilityReserveCharge: (facilityReserveCharge: FacilityReserveCharge[]) => void
}

interface State {
    items: PaymentItem[]
    totalCharge: Nullable<number>
}

class NatAdminFacilityReserveChargeViewComponent extends Component<Props, State>
    implements ReserveFacilityModelPaymentObserver {
    constructor(props: Props) {
        super(props);

        this.state = {
            items: [],
            totalCharge: null,
        }
    }

    async componentDidMount(): Promise<void> {
        this.props.reservationModel.addPaymentInformationObserver(this)
    }

    renderOptionTable(duration: number,
                      facilityOptionDetailInfo: NatFacilityOptionDetailInfo,
                      reservationOption: ReservationOption,
                      option: PaymentItem)
        : Nullable<ReactNode> {
        const {facilityReserveCategory} = this.props;

        const quantity = reservationOption.quantity;
        const unitName = facilityOptionDetailInfo.unitName;

        return (
            <>
                <TableCellWordBreakAll key={option.article}>
                    {option.article}：{quantity}{unitName}
                </TableCellWordBreakAll>
                <TableCell
                    colSpan={(facilityReserveCategory !== FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value) ? 1 : 4}>
                    {getDispCharge(option.charge, facilityReserveCategory)}円
                </TableCell>
                {facilityReserveCategory !== FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value &&
                <>
                    <TableCell colSpan={3}>
                        {facilityOptionDetailInfo.paymentType.label}
                        {(facilityOptionDetailInfo.paymentType.value === PAYMENT_TYPE.CASH.value) &&
                        <>
                            （現金支払ステータス：{
                            (facilityOptionDetailInfo.cashPaymentStatus) ?
                                CASH_PAYMENT_STATUS.codeToEnumConstants(
                                    facilityOptionDetailInfo.cashPaymentStatus).label :
                                CASH_PAYMENT_STATUS.YET_PAID.label
                        }）
                        </>
                        }
                    </TableCell>
                </>
                }
            </>
        )
    }

    renderOptionFormTable(): Nullable<ReactNode> {
        const {
            facilityReserveEditInfo, reservationOptions, facilityOptionsDetailInfo,
            stayAvailability, facilityReserveCategory, facilityName, facilityOptions
        } = this.props;

        const paymentItems: PaymentItem[] =
            (this.state.items.length === 0)
                ? [new PaymentItemForViewFacility(PAYMENT_TYPE.ADMIN_TRANSFER_ACCOUNT, null).toObject()]
                : this.state.items;

        // 施設情報
        const facilityChargeInfo: PaymentItem =
            paymentItems.filter(item => item.id === null)[0];

        const facilityPayMethod: PAYMENT_TYPE =
            PAYMENT_TYPE.codeToEnumConstants(facilityReserveEditInfo.facilityPaymentMethod);

        let facilityCashStatus: CASH_PAYMENT_STATUS = CASH_PAYMENT_STATUS.YET_PAID;
        if (facilityPayMethod.value === PAYMENT_TYPE.CASH.value) {
            if (facilityReserveEditInfo.cashPaymentStatus) {
                facilityCashStatus = CASH_PAYMENT_STATUS.codeToEnumConstants(facilityReserveEditInfo.cashPaymentStatus);
            }
        }

        // オプション情報
        const optionsChargeInfo: PaymentItem[] =
            paymentItems.filter(item => item.id !== null);

        // 料金計算できない場合、オプション予約情報から情報取得
        if (optionsChargeInfo.length === 0) {
            reservationOptions.map((reservationOption) => {

                const tmpPayMethod: NatFacilityOptionDetailInfo =
                    facilityOptionsDetailInfo.filter(
                        (facilityOptionDetailInfo) =>
                            facilityOptionDetailInfo.optionId === reservationOption.optionId)[0];

                const tmpFacilityOptions =
                    facilityOptions.filter(
                        (facilityOption) =>
                            facilityOption.optionId === reservationOption.optionId)[0];

                const tepItem: PaymentItem = {
                    id: tmpPayMethod.optionId,
                    article: tmpPayMethod.name,
                    quantityWithUnit: null,
                    paymentType: tmpPayMethod.paymentType,
                    charge: 0,
                    displayOrder: tmpFacilityOptions.sortOrder,
                };
                optionsChargeInfo.push(tepItem)
            })

            optionsChargeInfo.sort((a, b) => a.displayOrder - b.displayOrder)
        }

        // 施設の利用時間
        const startDateTime =
            convertToMoment(facilityReserveEditInfo.startDate, `${facilityReserveEditInfo.startTimeHour}:${facilityReserveEditInfo.startTimeMinute}`);
        const endDateTime =
            convertToMoment(facilityReserveEditInfo.endDate, `${facilityReserveEditInfo.endTimeHour}:${facilityReserveEditInfo.endTimeMinute}`);
        const displayDurationString = getDuration(startDateTime, endDateTime);

        return (
            <>
                <ConditionTableFixed>
                    <colgroup>
                        <col width={'15%'}/>
                        <col width={'15%'}/>
                        <col width={'10%'}/>
                        <col width={'15%'}/>
                        <col width={'10%'}/>
                        <col width={'10%'}/>
                    </colgroup>
                    <StyledTableCaption>料金情報</StyledTableCaption>
                    <TableBody>
                        <TableRow key={'test'}>
                            <TableRowName>施設利用料</TableRowName>
                            <TableCellWordBreakAll>
                                {facilityName}
                            </TableCellWordBreakAll>
                            <TableCell colSpan=
                                           {(facilityReserveCategory !==
                                               FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value) ?
                                               1 : 4}>
                                {getDispCharge(facilityChargeInfo.charge, facilityReserveCategory)}円
                            </TableCell>
                            {facilityReserveCategory !== FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value &&
                            <>
                                <TableCell colSpan={3}>
                                    {facilityPayMethod.label}
                                    {(facilityPayMethod.value === PAYMENT_TYPE.CASH.value) &&
                                    <>
                                        （現金支払ステータス：{facilityCashStatus.label}）
                                    </>
                                    }
                                </TableCell>
                            </>
                            }
                        </TableRow>
                        {optionsChargeInfo.map((option, index) => {
                            const targetFacilityOptionDetailInfo: NatFacilityOptionDetailInfo | undefined =
                                facilityOptionsDetailInfo.find(facilityOptionDetailInfo =>
                                    facilityOptionDetailInfo.optionId === option.id);

                            const targetReservationOption: ReservationOption | undefined =
                                reservationOptions.find(reservationOption =>
                                    reservationOption.optionId === option.id);

                            if (targetFacilityOptionDetailInfo && targetReservationOption) {
                                if (index === 0) {
                                    return (
                                        <TableRow key={option.id + '_' + index}>
                                            <TableRowName rowSpan={optionsChargeInfo.length}>オプション</TableRowName>
                                            {this.renderOptionTable(
                                                displayDurationString,
                                                targetFacilityOptionDetailInfo,
                                                targetReservationOption,
                                                option,
                                            )}
                                        </TableRow>
                                    )
                                } else {
                                    return (
                                        <TableRow key={option.id + '_' + index}>
                                            {this.renderOptionTable(
                                                displayDurationString,
                                                targetFacilityOptionDetailInfo,
                                                targetReservationOption,
                                                option,
                                            )}
                                        </TableRow>
                                    )
                                }
                            }
                        })}
                        <TableRow key={'gouukei'}>
                            <TableRowName>合計金額</TableRowName>
                            <TableCell colSpan={5}>
                                {getDispCharge(this.state.totalCharge, facilityReserveCategory)}円
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </ConditionTableFixed>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        return (
            <>
                {this.renderOptionFormTable()}
            </>
        )
    }

    onChangePayment(paymentInformation: PaymentInformation): void {
        const {facilityReserveEditInfo, facilityOptionsDetailInfo} = this.props;

        this.setState({
            items: paymentInformation.items,
            totalCharge: paymentInformation.totalCharge,
        });


        const facilityChargeInfo: PaymentItem =
            paymentInformation.items.filter(item => item.id === null)[0];

        const facilityPayMethod: PAYMENT_TYPE =
            PAYMENT_TYPE.codeToEnumConstants(facilityReserveEditInfo.facilityPaymentMethod);

        let facilityCashStatus: CASH_PAYMENT_STATUS = CASH_PAYMENT_STATUS.YET_PAID;

        if (facilityPayMethod.value === PAYMENT_TYPE.CASH.value) {
            facilityCashStatus = CASH_PAYMENT_STATUS.codeToEnumConstants(facilityReserveEditInfo.cashPaymentStatus);
        }


        const facilityReserveCharge: FacilityReserveCharge[] = [
            {
                optionId: '',
                optionName: '',
                unitCharge: '',
                paymentMethod: facilityPayMethod.value,
                cashPaymentStatus: facilityCashStatus.value,
                charge: (facilityChargeInfo) ? Number(facilityChargeInfo.charge) : null,
            },
        ];
        const optionsChargeInfo: PaymentItem[] =
            paymentInformation.items.filter(item => item.id !== null);

        optionsChargeInfo.map((option) => {
            const tmpPayMethod: NatFacilityOptionDetailInfo =
                facilityOptionsDetailInfo.filter(
                    (facilityOptionDetailInfo) =>
                        facilityOptionDetailInfo.optionId === option.id)[0];

            facilityReserveCharge.push({
                optionId: (option.id !== null) ? String(option.id) : '',
                optionName: option.article,
                unitCharge: `${tmpPayMethod.charge}円/${tmpPayMethod.chargeUnit.label}`,
                paymentMethod: tmpPayMethod.paymentType.value,
                cashPaymentStatus: tmpPayMethod.cashPaymentStatus,
                charge: (option.charge === null) ? null : Number(option.charge),
            })
        });

        this.props.onChangeTotalCharge(paymentInformation.totalCharge);
        this.props.onChangeFacilityReserveCharge(facilityReserveCharge);
    }
}

// 施設利用時間取得
const getDuration = (
    startMoment: moment.Moment, endMoment: moment.Moment,
): number => {
    const {durationInMinute} = calculateDurations(startMoment, endMoment);
    if (durationInMinute < 0) {
        return COMMON_CONSTANTS.INVALID_CALCULATE_RESULT
    }

    const actualHour: number = (Math.floor(durationInMinute / 60)) * 60;
    const actualMinute: number = durationInMinute % 60;

    const actual: number = actualHour + actualMinute;

    return actual
};

// 表示料金
const getDispCharge = (
    charge: Nullable<number>, reserveCategory: string,
): string => {
    if (reserveCategory === FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value) {
        return '0';
    } else if (charge) {
        return String(charge);
    } else {
        return '-';
    }
};

export default NatAdminFacilityReserveChargeViewComponent;

const TableCellWordBreakAll = styled(TableCell)`
&.MuiTableCell-root {
    word-break : break-all;
}
`;
